import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import i18next from 'i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import TailorLoading from '../Loading';
import AppBackLink from '../../../components/BackLink';
import { selectTailors } from '../../store/selectors';
import { ReactComponent as HighlightIcon } from '../../../images/svg/highlight-arrow.svg';
import classes from './Details.module.css';
import { getPage } from '../../../utils/pages';
import { useParams } from '@reach/router';
import { Head } from '../../../components/Head/Head';

export default function TailorDetails(props) {
  const { tailorName: tailorNameParam } = useParams();
  const { t } = useTranslation();
  const tailors = useSelector(selectTailors);

  function renderTailorView() {
    if (!tailors) {
      return <TailorLoading />;
    }

    const tailor = tailors.find((craftsman) => craftsman.seo?.url.toLowerCase() === tailorNameParam.toLowerCase()) || tailors[0];
    const { contact } = tailor.addressSecondary;
    const tailorName = contact?.fullName ?? `${contact?.firstName} ${contact?.lastName}`;
    const seoDescription = tailor.seo?.[i18next.language]?.description || '';

    const workExamples = tailor.additionalPicUrls.map((url, i) => (
      <div className="col-12 col-sm-6 col-lg-3" key={i}>
        <div className={classes.workExample}>
          <LazyLoadImage
            className={classes.workImage}
            alt="Work Example"
            src={url}
            effect="blur"
            // height={image.height}
            // width={image.width}
          />
        </div>
      </div>
    ));

    const bodyTexts = tailor.sections[i18next.language].map((section, i) => {
      const ps = section.texts.map((text, i) => {
        return <p key={i}>{text}</p>;
      });

      return (
        <div key={i}>
          <div className={classes.title}>{section.title}</div>
          {ps}
        </div>
      );
    });

    return (
      <div className="container">
        <Head
          title={tailorName}
          description={seoDescription}
          imgUrlSecure={tailor.profilePicUrl}
          ogType="profile"
          ogUrl={window.location.href}
        />
        <AppBackLink to={getPage('tailorList')} />
        <div className="row mb-4 pt-2">
          <div className="col-12 col-md-6 col-xl-5">
            <div className={classes.widthLimiter}>
              <div className={classes.photoWrapper}>
                <LazyLoadImage
                  className={classes.photoImage}
                  alt="Tailor"
                  src={tailor.profilePicUrl}
                  effect="blur"
                  // height={image.height}
                  // width={image.width}
                />
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 pt-lg-4">
            <div className="h4 with-bar mb-1">{tailorName}</div>
            {bodyTexts}
            <p>
              <b>{t('Address')}:</b> {tailor.addressPrimary}
            </p>
          </div>
        </div>
        <div className="h5 with-bar mb-3">{t(tailor.workPicturesTranslationKey[i18next.language]) || 'Pictures of her work'}</div>
        <div className="row mb-5">{workExamples}</div>
        <div className="h4 mb-5">
          {`“${tailor.quote[i18next.language]}“`}
          <HighlightIcon className={classes.highlightIcon} />
        </div>
      </div>
    );
  }

  return <div>{renderTailorView()}</div>;
}
